// extracted by mini-css-extract-plugin
module.exports = {"root":"header_root__VCDay","rootWhiteBackground":"header_rootWhiteBackground__fDCSR","rootCreamBackground":"header_rootCreamBackground__G_zIv","logotype":"header_logotype__CXuIn"};